import React, { createContext, useContext, useMemo } from 'react';
import usePermissionsLoader from 'hooks/permissions/usePermissionsLoader';
import { createPermissionSelectors } from 'permissions/helpers/createPermissionSelectors';

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const { permissions, permissionCodes, groupedPermissions, permissionsLoading } =
    usePermissionsLoader();

  const permissionSelectors = useMemo(
    () => createPermissionSelectors({ permissions, permissionCodes, groupedPermissions }),
    [permissions, permissionCodes, groupedPermissions]
  );

  const value = {
    permissions,
    permissionCodes,
    groupedPermissions,
    permissionsLoading,
    ...permissionSelectors,
  };

  return (
    <PermissionsContext.Provider value={value}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions debe usarse dentro de PermissionsProvider');
  }
  return context;
};
